import { SidebarTrigger } from "../../components/ui/sidebar"
import { Button } from "../../components/ui/button"
import { Bell, User } from "lucide-react"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../components/ui/dropdown-menu"

interface AdminHeaderProps {
  activeSection: string
}

const sectionTitles: Record<string, string> = {
  dashboard: "Dashboard Overview",
  "healing-pavilion/healing-dashboard": "Healing Pavilion Dashboard",
  "healing-pavilion/availability": "Availability Management",
  "healing-pavilion/bookings": "Bookings Management",
  "healing-pavilion/settings": "Settings & Configuration",
  users: "User Management",
  registrants: "Portal Registrants",
  comments: "Comment Moderation",
  "qr-generator": "QR Code Generator",
  "email-tools": "Email & Messaging Tools",
  slider: "Homepage Slider Control",
  "library-settings": "TSO Content Library Settings",
  linktree: "LinkTree Page Builder",
  "social-seo": "Social Media & SEO Settings",
  "site-settings": "General Site Settings",
  notifications: "Notification Settings",
  security: "Security Logs",
}

export function AdminHeader({ activeSection }: AdminHeaderProps) {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center gap-4 px-4">
        <SidebarTrigger children/>
        <div className="flex-1">
          <h1 className="text-lg font-semibold">{sectionTitles[activeSection] || "Admin Panel"}</h1>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm">
            <Bell className="h-4 w-4" />
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm">
                <User className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem>Profile</DropdownMenuItem>
              <DropdownMenuItem>Settings</DropdownMenuItem>
              <DropdownMenuItem>Sign out</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  )
}
